import { IconButton, IconButtonProps } from "@mui/material";
import { forwardRef } from "react";

export default forwardRef((props: IconButtonProps | any, ref) => {
	return <IconButton ref={ref} {...props} />;
});
